import { makeStyles } from '@material-ui/core/styles';
import { fill } from '../../../utils/contrastSvgAttributes';

export const useStyles = makeStyles(() => ({
  backIcon: {
    margin: '8px',
    width: '32px',
    height: '32px',
    backgroundColor: '#3d4083',
    color: 'white',
    justifyContent: 'center',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#5155aa',
    },
    '& img': {
      marginBottom: '2px',
    },
  },
  navIcon: {
    color: fill,
  },
  navMenuIcon: {
    position: 'relative',
    left: '-5px',
    marginRight: '5px',
  },
  userProfileContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '15px',
    position: 'relative',
    top: '8px',
  },
  messageIcon: {
    width: '24px',
  },
  liHover: {
      '&:hover': {
        fill: 'red'
      }
  }
}));
